import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AutoPopulateForm } from './forms/AutoPopulateForm';
import FormManager from './forms/FormManager';
import ListManager from './tables/ListManager';
import ButtonNavigation from './ButtonNavigation';
import ModalHandler from './modal/ModalHandler';
import { returnHostUrl } from '../util/axiosHelper';
import { CROSS_DOMAIN_ACCOUNT_SEARCH } from '../store/actions/types';
import { accountTypeCommercial, messages } from '../util/constants';
import { fetchCustomerAccounts } from '../store/actions/accountActions';
export class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displaySearch: true,
      displayCSR: false,
    };

    this.handleCSRSearchDisplay = this.handleCSRSearchDisplay.bind(this);
    this.handleAccountSearchDisplay = this.handleAccountSearchDisplay.bind(this);
  }

  /**
   * Checks if an object is empty
   * @param {Object} obj - The object to check
   * @returns {boolean} True if object has no own properties, false otherwise
   */
  isEmpty = obj => Object.entries(obj).length === 0;

  static modifyFormData(formValues) {
    const { addressLineOne, city, firstName, lastName, state, zipCode } = formValues;
    const fName = firstName === undefined ? '' : firstName;
    const lName = lastName === undefined ? '' : lastName;

    return {
      ...formValues,
      customerName: `${fName} ${lName}`,
      customerAddress: `${addressLineOne} ${city} ${state} ${zipCode}`,
    };
  }

  handleAccountSearchDisplay() {
    this.setState(() => ({
      displaySearch: true,
      displayCSR: false,
    }));
  }

  handleCSRSearchDisplay() {
    this.setState(() => ({
      displayCSR: true,
      displaySearch: false,
    }));
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const accountNumber = params.get('ACCTNUM');
    const encodedState = params.get('state');
    if (accountNumber) {
      this.props.dispatch(fetchCustomerAccounts({ AccountNumber: accountNumber }));
    } else if (encodedState) {
      try {
        const decodedParams = new URLSearchParams(atob(encodedState));
        const stateAccountNumber = decodedParams.get('ACCTNUM');
        if (stateAccountNumber) {
          this.props.dispatch(fetchCustomerAccounts({ AccountNumber: stateAccountNumber }));
        }
      } catch (error) {
        console.warn('Failed to decode state parameter', error.message);
      }
    }
  }

  componentDidUpdate() {
    const { chosenAccount } = this.props;
    const isResiDomain = returnHostUrl().isResi;
    if (!this.isEmpty(chosenAccount)) {
      if (chosenAccount.accountType === accountTypeCommercial && isResiDomain) {
        this.props.dispatch({
          type: CROSS_DOMAIN_ACCOUNT_SEARCH,
          payload: {
            message: messages.smbAccountMessage,
            account: chosenAccount,
            isResiDomain: isResiDomain,
          },
        });
      } else if (chosenAccount.accountType !== accountTypeCommercial && !isResiDomain) {
        this.props.dispatch({
          type: CROSS_DOMAIN_ACCOUNT_SEARCH,
          payload: {
            message: messages.resiAccountMessage,
            account: chosenAccount,
            isResiDomain: isResiDomain,
          },
        });
      }
    }
  }

  render() {
    const { chosenAccount, chosenAgent } = this.props;
    let initValue;

    if (!this.isEmpty(chosenAccount)) {
      initValue = Landing.modifyFormData(chosenAccount);
    }

    if (!this.isEmpty(chosenAgent)) {
      initValue = chosenAgent;
    }

    return (
      <div>
        <ModalHandler />
        <div className={'card-container'}>
          {initValue && <AutoPopulateForm display={this.state} values={initValue} />}
          <FormManager display={this.state} />
        </div>
        <ListManager display={this.state} />
        <ButtonNavigation
          handleSearchDisplay={this.handleAccountSearchDisplay}
          handleCSRDisplay={this.handleCSRSearchDisplay}
        />
      </div>
    );
  }
}

export function mapStateToProps({
  targetAccount: { didPickAccount, chosenAccount },
  targetAgent: { didPickAgent, chosenAgent },
}) {
  return {
    didPickAccount,
    didPickAgent,
    chosenAccount,
    chosenAgent,
  };
}

export default connect(mapStateToProps, null)(Landing);
